module.exports = __webpack_public_path__ + "img/helpdetail3.51b9bdea.png";